import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import EuroSymbolIcon from "@mui/icons-material/EuroSymbol";
import QueryBuilderIcon from "@mui/icons-material/QueryBuilder";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import AOS from "aos";
import "aos/dist/aos.css";
import { useCallback, useEffect } from "react";
import { Button } from "react-bootstrap";
import motivationImage from "../../assets/images/moon-restaurant.jpg";
import foodImage from "../../assets/images/motivation-3.jpg";

// Konfiguration der Button-Links für die Menüdateien
const menuLinks = [
  {
    label: "Mittagskarte",
    href: `${process.env.PUBLIC_URL}/MITTAGSKARTE.pdf`,
  },
  {
    label: "Abendkarte",
    href: `${process.env.PUBLIC_URL}/ABENDKARTE.pdf`,
  },
];

const MotivationSection = () => {
  const initializeAOS = useCallback(() => {
    AOS.init({ once: true });
  }, []);

  useEffect(() => {
    initializeAOS();
  }, [initializeAOS]);

  return (
    <section className="motivation-section-wrapper">
      <div className="motivation-section" id="about-us-section">
        <div className="motivation-text" data-aos="fade-right">
          <h2>Motivation</h2>
          <hr />
          <p data-aos="fade-right">
            Willkommen im <span className="restaurant-name">Moon</span>{" "}
            Restaurant! <br /> <br /> Genießen Sie eine kulinarische Reise durch
            die Welt der asiatischen Küche. Unsere Gerichte aus frischen Zutaten
            werden kunstvoll präsentiert und verzaubern Sie mit Aromen und
            Texturen. <br /> <br /> Bei uns im{" "}
            <span className="restaurant-name">Moon</span> geht es nicht nur um
            Mahlzeiten, sondern um ein unvergessliches Erlebnis. Wir bieten
            authentische asiatische Gerichte, die den Gaumen erfreuen und die
            Seele nähren. Unser stilvolles Ambiente lädt zum Verweilen ein, egal
            ob alleine, mit Freunden oder Familie. Unser hervorragender Service
            wird Sie begeistern und dazu einladen, immer wieder zurückzukehren.{" "}
            <br /> <br /> Besuchen Sie uns im{" "}
            <span className="restaurant-name">Moon</span> Restaurant und erleben
            Sie unsere Liebe zur asiatischen Küche in einer unvergesslichen
            Atmosphäre.
          </p>
        </div>
        <div className="motivation-image">
          <img src={motivationImage} alt="restaurant" data-aos="fade-left" />
        </div>
      </div>
      <div className="motivation-section-second">
        <div className="motivation-text" data-aos="fade-left">
          <h2>Erlebe die Vielfalt der asiatischen Küche </h2>
          <hr />
          <p>
            Besuch uns mal und genieße die kulinarische Vielfalt der asiatischen
            Küche!
          </p>
          <h4>
            <DirectionsBusIcon /> Öffentliche Verkehrsmittel:{" "}
          </h4>
          <p>
            Wenn Sie mit öffentlichen Verkehrsmitteln anreisen, können Sie die{" "}
            <strong>Buslinien: 8, 108, 552, 570 oder 572 nehmen</strong> und an
            der Haltestelle "Altdorf - Hahn" aussteigen. Von dort aus sind es
            nur wenige Gehminuten bis zum Restaurant. <br /> <br /> Falls Sie
            mit dem Auto anreisen gibt es{" "}
            <strong>ausreichend Parkplätze in der Nähe des Restaurants</strong>.
          </p>
          <h4>
            <QueryBuilderIcon /> Unsere Öffnungszeiten:{" "}
          </h4>
          <ul>
            <li>Mo.: Ruhetag</li>
            <li>Di. – Do.: 11:30 - 15:00, 17:00 - 22:30 Uhr</li>
            <li>Fr. - So.: 12:00 - 15:00, 17:00 - 22:30 Uhr</li>
            <hr />
            <li>24. Dezember: Geschlossen</li>
            <li>25. Dezember: 12:00 - 15:00, 17:00 - 22:00 Uhr</li>
            <li>31. Dezember: 12:00 - 15:00, 17:00 - 01:00 Uhr</li>
            <li>01. Januar: 17:00 - 22:00 Uhr</li>
          </ul>
          <h4>
            <EuroSymbolIcon /> Zahlungsoptionen:
          </h4>
          <ul>
            <li className="attention-text">
              Bitte beachten Sie: Nur <strong>Barzahlung</strong> ist möglich!
            </li>
          </ul>
          <br />
          <div className="foodMenu-buttons">
            {menuLinks.map((link, index) => (
              <Button
                key={index}
                variant="outline-light"
                className="mr-3"
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Download ${link.label}`}
              >
                {link.label} <RestaurantMenuIcon />
              </Button>
            ))}
          </div>
          <br />
        </div>
        <div className="motivation-image" data-aos="fade-right">
          <img src={foodImage} alt="restaurant" />
        </div>
      </div>
    </section>
  );
};

export default MotivationSection;
